import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import ReduxThunk from 'redux-thunk'
import DashboardReducer from './components/Dashboard/DashboardReducer'
import searchReducer from 'components/Search/searchReducer'
import BOSearchReducer from 'components/BOSearch/BOSearchReducer'
import managerReducer from 'components/FormManager/FormManagerReducer'
import wizardReducer from 'components/Wizard2/WizardReducer'
import designerReducer from 'components/Designer2/DesignerReducer'
import formsReducer from 'components/Forms/FormsReducer'
import MyRecordsReducer from 'components/MyRecords/MyRecordsReducer'
import MyWorkQueueReducer from 'components/MyWorkQueue/MyWorkQueueReducer'
import MiscellaneousMyWorkQueueReducer from 'components/MiscRecords/MiscellaneousMyWorkQueueReducer'
import MiscellaneousPublicSearchReducer from 'components/MiscRecords/MiscellaneousPublicSearchReducer'
import MiscellaneousMyRecordsReducer from 'components/MiscRecords/MiscellaneousMyRecordsReducer'
import WorkviewReducer from 'components/WorkviewManager/WorkviewReducer'
import SettingsReducer from 'components/Settings/SettingsReducer'
import HomeReducer from 'components/Home/HomeReducer'
import AuthReducer from './Auth/AuthReducer'
import AppSettingsReducer from 'components/AppSettings/AppSettingsReducer'
import AppSettingTypesReducer from 'components/AppSettings/AppSettingTypesReducer'
import ImageViewerReducer from 'components/ImageViewer/ImageViewerReducer'
import ReportViewerReducer, {
  ADD_PDF_TO_LIST,
  /*REMOVE_PDF_FROM_LIST, CLEAR_PDF_LIST,*/ REFRESH_PDF_LIST /*CLEAR_WINDOW_INSTANCE*/,
} from './components/ReportViewer/ReportViewerReducer'
import HistorySidebarReducer from 'components/HistorySidebar/HistorySidebarReducer'
import ManageUserInfoReducer from 'components/UserManager/ManageUserInfoReducer'
import Correspondence2Reducer from 'components/WVMCorrespondence/Correspondence2Reducer'
import RecordReducer from './components/RecordDetailsPage/RecordDetailsReducer'
import ReceiptReducer from './components/Accounting/ReceiptValidation/ReceiptValidationReducer'
import ReconcileReducer from './components/Accounting/Reconcile/ReconcileReducer'
import UnreconcileReducer from './components/Accounting/UnreconcilePaymentBatch/UnreconcileReducer'
import PostDistributionReducer from './components/Accounting/PostDistributions/PostDistributionReducer'
import PostPaymentReducer from './components/Accounting/PostPaymentBatch/PostPaymentReducer'
import PrintQueueReducer from './components/PrintQueue/PrintQueueReducer'
import { routerMiddleware, connectRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import rfl, { engine as rfe } from 'components/Wizard2/resolveFieldLogic'
import ls from 'local-storage'
import {
  createStateSyncMiddleware,
  withReduxStateSync,
  initStateWithPrevTab,
} from 'redux-state-sync'
import Workview2Reducer from './components/WVManager/Workview2Reducer'

export const SET_USING_LIEN_PARTY_EXTENSIONS = 'SET_USING_LIEN_PARTY_EXTENSIONS'
export const SET_ACTIVE_SOURCE_TYPES = 'SET_ACTIVE_SOURCE_TYPES'
export const SET_MISC_RECORDS_SELECTED_MODULE = 'SET_MISC_RECORDS_SELECTED_MODULE'

export const resolveFieldLogic = rfl
export const resolveFieldEngine = rfe
export const history = createBrowserHistory()
const routeMiddleware = routerMiddleware(history)
const connectedRouter = connectRouter(history)
const DEPRECATE_IE = process.env.DEPRECATE_IE
const DEPRECATE_NON_CHROMIUM_EDGE = process.env.DEPRECATE_NON_CHROMIUM_EDGE
const reduxStateSyncConfig = {
  whitelist: [
    /*`SET_ENVELOPE_ID`, REMOVE_PDF_FROM_LIST, ADD_PDF_TO_LIST, CLEAR_PDF_LIST, */ ADD_PDF_TO_LIST,
    REFRESH_PDF_LIST,
  ],
}

const getIsUnsupportedBrowser = () => {
  const checks = []
  if (DEPRECATE_IE) {
    checks.push(!!window.MSInputMethodContext && !!document.documentMode)
  }
  if (DEPRECATE_NON_CHROMIUM_EDGE) {
    checks.push(navigator.userAgent.indexOf('Edge') !== -1)
  }
  return checks.length ? checks.some((x) => x) : false
}

let initialState = {
  sidebarCollapsed: false,
  isMobile: document.body.clientWidth < 600 ? true : false,
  sidebarShown: false,
  overrideSidebarResizing: false,
  showLogin: false,
  appError: false,
  toastError: '',
  toastSuccess: '',
  appSettings: {},
  currentCategory: '',
  cartQuantity: 0,
  isUnsupportedBrowser: getIsUnsupportedBrowser(),
  announcerMessages: [],
  officeHeaderTitle: '',
  usingLienExtensions: null,
  activeSourceTypes: [],
  miscRecordsSelectedModules: {},
}

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_APP_STATE':
      return initialState
    case 'TOGGLE_SIDEBAR_COLLAPSE':
      return { ...state, sidebarCollapsed: action.collapse }
    case 'TOGGLE_MOBILE_STATE':
      return { ...state, isMobile: action.isMobile }
    case 'TOGGLE_SIDEBAR_SHOW':
      return { ...state, sidebarShown: action.sidebarShown }
    case 'OVERRIDE_SIDEBAR_RESIZING':
      return { ...state, overrideSidebarResizing: action.overrideSidebarResizing }
    case 'TOGGLE_SHOW_LOGIN':
      return { ...state, showLogin: action.showLogin }
    case 'SET_APP_ERROR':
      return {
        ...state,
        appError: {
          type: action.errorType,
          error: action.error,
          show: action.show === false ? false : true,
        },
      }
    case 'CLEAR_APP_ERROR':
      return { ...state, appError: false }
    case 'SET_APP_SETTINGS':
      return { ...state, appSettings: action.appSettings }
    case 'SET_ERROR_TOAST':
      return { ...state, toastError: action.error }
    case 'CLEAR_ERROR_TOAST':
      return { ...state, toastError: '' }
    case 'SET_SUCCESS_TOAST':
      return { ...state, toastSuccess: action.success }
    case 'CLEAR_SUCCESS_TOAST':
      return { ...state, toastSuccess: '' }
    case 'SET_OFFLINE':
      return {
        ...state,
        appSettings: { ...action.appSettings, WEBSITE_PORTAL_OFFLINE_YN: action.offline },
      }
    case 'SET_CURRENT_CATEGORY':
      const userCache = ls.get('USER_CACHE') || {}
      const auth = store.getState().auth
      if (auth.loggedIn) {
        ls.set('USER_CACHE', { ...userCache, [auth.WEB_USER_ID]: action.category })
      }
      return { ...state, currentCategory: action.category }
    case 'SET_CART_QUANTITY':
      return { ...state, cartQuantity: action.quantity }
    case 'CLEAR_CART_QUANTITY':
      return { ...state, cartQuantity: 0 }
    case 'SET_UNSUPPORTED_BROWSER':
      return { ...state, isUnsupportedBrowser: action.isUnsupportedBrowser }
    case 'ANNOUNCE':
      return { ...state, announcerMessages: [...state.announcerMessages, action.message] }
    case 'SET_OFFICE_HEADER_TITLE':
      return { ...state, officeHeaderTitle: action.officeHeaderTitle }
    case SET_USING_LIEN_PARTY_EXTENSIONS:
      return { ...state, usingLienExtensions: action.usingLienExtensions }
    case SET_ACTIVE_SOURCE_TYPES:
      return { ...state, activeSourceTypes: action.activeSourceTypes }
    case SET_MISC_RECORDS_SELECTED_MODULE:
      return {
        ...state,
        miscRecordsSelectedModules: {
          ...state.miscRecordsSelectedModules,
          [action.sourceTypeParam]: action.moduleId,
        },
      }
    default:
      return state
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

let store = createStore(
  withReduxStateSync(
    combineReducers({
      router: connectedRouter,
      app: appReducer,
      search: searchReducer,
      boSearch: BOSearchReducer,
      formManager: managerReducer,
      forms: formsReducer,
      wizard: wizardReducer,
      designer: designerReducer,
      myRecords: MyRecordsReducer,
      queue: MyWorkQueueReducer,
      miscWorkQueue: MiscellaneousMyWorkQueueReducer,
      miscPublicSearch: MiscellaneousPublicSearchReducer,
      miscMyRecords: MiscellaneousMyRecordsReducer,
      workview: WorkviewReducer,
      workview2: Workview2Reducer,
      settings: SettingsReducer,
      correspondence2: Correspondence2Reducer,
      userInfo: ManageUserInfoReducer,
      auth: AuthReducer,
      home: HomeReducer,
      appSettings: AppSettingsReducer,
      appSettingTypes: AppSettingTypesReducer,
      imageViewer: ImageViewerReducer,
      reportViewer: ReportViewerReducer,
      historySidebar: HistorySidebarReducer,
      record: RecordReducer,
      receipt: ReceiptReducer,
      reconcile: ReconcileReducer,
      unreconcile: UnreconcileReducer,
      postDistributions: PostDistributionReducer,
      postPayment: PostPaymentReducer,
      dashboard: DashboardReducer,
      printQueue: PrintQueueReducer,
    })
  ),
  composeEnhancers(
    applyMiddleware(ReduxThunk, routeMiddleware, createStateSyncMiddleware(reduxStateSyncConfig))
  )
)

initStateWithPrevTab(store)

export default store
